import React,{useState,useEffect} from 'react';
import { Router, Location, Redirect,Link,useNavigate } from 'react-router-dom';
import Chart from "react-apexcharts";
import { createGlobalStyle } from 'styled-components';
import { DOCUMENT_LIST } from './../../prefixed/documents';
import {URLPREFIX,API_CORE_SERVER,RS_LABEL,DDMMYYYY_LABEL} from './../../constants';
import {stringToHex} from "./../forms/validator";
import axios from 'axios';

const BLOCKS=["Chitarpur","Dulmi","Gola","Mandu","Patratu","Ramgarh"];

const chartData=[];
let stateCount={
			series: [{
              name: 'Projects',
              data: chartData
            }],
            options: {
              chart: {
                type: 'bar',
              },
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: '25%',
				  borderRadius:5,
                  borderRadiusApplication:'rounded'
                },
              },
              dataLabels: {
                enabled: false
              },
              stroke: {
                show: true,
                width: 2,
                colors: ['transparent']
              },
              xaxis: {
                categories: BLOCKS,
              },
              yaxis: {
                title: {
                  text: 'Number of projects'
                }
              },
			  colors:['#2397ff'],
              fill: {
				type: "gradient",
				gradient: {
				  shadeIntensity: 1,
				  opacityFrom: 0.7,
				  opacityTo: 0.9,
				  stops: [0, 10, 100]
				}
			  },
              tooltip: {
                y: {
                  formatter: function (val) {
                    return " " + val + " projects"
                  }
                }
              }
            },
    };
let stateAmount={
		series: [{
		  name: 'Projects',
		  data: chartData
		}],
		options: {
		  chart: {
			type: 'bar',
		  },
		  plotOptions: {
			bar: {
			  horizontal: false,
			  columnWidth: '25%',
			  borderRadius:5,
			  borderRadiusApplication:'rounded'
			},
		  },
		  dataLabels: {
			enabled: false
		  },
		  stroke: {
			show: true,
			width: 2,
			colors: ['transparent']
		  },
		  xaxis: {
			categories: BLOCKS,
		  },
		  yaxis: {
			title: {
			  text: 'Rs Projects Cost in Lakh'
			}
		  },
		  colors:['#2397ff'],
		  fill: {
			type: "gradient",
			gradient: {
			  shadeIntensity: 1,
			  opacityFrom: 0.7,
			  opacityTo: 0.9,
			  stops: [0, 10, 100]
			}
		  },
		  tooltip: {
			y: {
			  formatter: function (val) {
				return " " + (val/100000).toFixed(3) + " lakh"
			  }
			}
		  }
		},
};	

let stateDelayBetween={
	series:chartData,
	
	options: {
		labels:["30-60","60-90","90-180","180-N"],
		legend:{
			position:'bottom'
		}
	},
};	

let stateGeoDensity={
	series: [{
		name: "Assests density",
		data: []
		}],
	options: {
	  chart: {
		type: 'scatter',
		zoom: {
			enabled: true,
			type: 'xy'
		  }
	  },
	  xaxis: {
			title: {
				text: 'Latitude'
		  	},
				labels: {
                  formatter: function(val) {
                    return parseFloat(val).toFixed(5)
                  }
                },
				min: (min) => {
					return 23; 
				  },
				  max: (max) => {
					return 24; 
				  }	
	  },
	  yaxis: {
		title: {
		  text: 'Longitude'
		},
		min: (min) => {
			return 84; 
		  },
		  max: (max) => {
			return 85; 
		  }
	  },
	  colors:['#2397ff'],
	  fill: {
		type: "gradient",
		gradient: {
		  shadeIntensity: 1,
		  opacityFrom: 0.7,
		  opacityTo: 0.9,
		  stops: [0, 10, 100]
		}
	  },
	  markers: {
		size:[5]
	  }
	},
};	
const JComponent= ({modalObject}) => {
  const navigate=useNavigate();
  const [projectsDelayBetween,setProjectsDelayBetween]=useState(stateDelayBetween);
  const [projectsBlockWiseChart,setProjectsBlockWiseChart]=useState(stateCount);
  const [projectsAmountBlockWiseChart,setAmountProjectsBlockWiseChart]=useState(stateAmount);
  const [projectsGeoDensityChart,setProjectsGeoDensityChart]=useState(stateGeoDensity);
  const [totalProjectCount,setTotalProjectCount]=useState("");
  const [totalOngoingCount,setTotalOngoingCount]=useState("");
  const [totalCompletedCount,setTotalCompletedCount]=useState("");
  const [crossDeadline,setCrossDeadline]=useState("");
  const [averageDelayedDays,setAverageDelayedDays]=useState("");
  const [notInUse,setNotInUse]=useState("");
  const [totalExpenditure,setTotalExpenditure]=useState(0);
  const [rows,setRows]=useState([]);
  const [progressCountRows,setProgressCountRows]=useState([]);
  const [role,setRole]=useState("");
  const [performanceCount,setPerformanceCount]=useState({
	"b30":0,
	"b50":0,
	"b70":0,
	"b100":0
});
const [delayCount,setDelayCount]=useState({
	"d30":0,
	"d60":0,
	"d90":0,
	"d180":0
});
const [starsCount,setStartsCount]=useState({
	"first":0,
	"second":0,
	"third":0,
	"four":0,
	"five":0
});
  useEffect(()=>{
	  if(localStorage.getItem("_xoxre")==="9999"){
		  setRole("9999");
	  }
  },[])  
  useEffect(()=>{
	loadAssetList();
	
  },[]);
  useEffect(()=>{
	//console.log(rows);
	fetchProjectsBlockWise();
	fetchPerformanceCategory();
	fetchDelayCount();
	fetchStarsCount();
	loadUpdatedProgressCounts();
  },[rows]);
 
  const loadAssetList=()=>{
	let _rows=[];
	let _d={
		token:localStorage.getItem("_xoxex"),
		email:localStorage.getItem("_xoxem"),
	};
	let idata=stringToHex(JSON.stringify(_d));
	var config = {
		method: 'post',
		url: API_CORE_SERVER+"/api/document/get-documents.php",
		headers: { 
			'Content-Type': 'application/x-www-form-urlencoded',
			//'Content-Type': 'application/json', 
		},
		data:"i="+idata
	  };
	axios(config)
		.then((response)=>{
			if(response.status===200 && response.data){
				let data=response.data;
				if(data.status===1 && data.data && data.data.length>0){
					let records=data.data;
					for(let i=0;i<records.length;i++){
					  let assetId=records[i].assetId;
					  try{
							
					  		let rec=JSON.parse(records[i].data.replace(new RegExp('\r', 'g'),'').replace(new RegExp('\n', 'g'),''));
							  _rows.push({ 
								assetId:assetId,
								assetType:rec.assetInfo.assetType,
								assetName:rec.assetInfo.assetName,
								implementAgency:rec.assetInfo.implementAgency,
								fundingAgency:rec.assetInfo.fundingAgency,
								userAgency:rec.assetInfo.userAgency,
								assetDescription:rec.assetInfo.assetDescription,
								panchayat:rec.assetInfo.panchayat,
								block:rec.assetInfo.block,
								beneficiary:rec.assetInfo.beneficiary,
								agrCost:rec.assetDetail.agrCost,
								agrDate:rec.assetDetail.agrDate,
								estCost:rec.assetDetail.estCost,
								estWorkStartDate:rec.assetDetail.estWorkStartDate,
								estWorkCompleteByDays:rec.assetDetail.estWorkCompleteByDays,
								workStartDate:rec.assetDetail.workStartDate,
								workFinishDate:rec.assetDetail.workFinishDate,
								workStatus:rec.assetDetail.workStatus,	// Ongoing | Completed | Paused
								workProgress:rec.assetDetail.workProgress, // 5 10 15 20.....100
								lat:rec.assetDetail.lat,
								lng:rec.assetDetail.lng,
								inUse:rec.assetInfo.inUse,
								name:rec.contractorInfo.name,
								photos:rec.assetDetail.photos
							});
					  }catch(e){
							console.log("EXP://"+assetId);
					  }
					} // loop
					setRows(_rows);
				}
				
			}
			
		}).catch((er)=>{
			console.log(er);
		})
  }
  const loadUpdatedProgressCounts=()=>{
	let _rows=[];
	let _d={
		token:localStorage.getItem("_xoxex"),
		email:localStorage.getItem("_xoxem"),
	};
	let idata=stringToHex(JSON.stringify(_d));
	var config = {
		method: 'post',
		url: API_CORE_SERVER+"/api/document/get-updated-progress-count.php",
		headers: { 
			'Content-Type': 'application/x-www-form-urlencoded',
			//'Content-Type': 'application/json', 
		},
		data:"i="+idata
	  };
	axios(config)
		.then((response)=>{
			if(response.status===200 && response.data){
				let data=response.data;
				if(data.status===1 && data.data && data.data.length>0){
					let records=data.data;
					for(let i=0;i<records.length;i++){
					  let imonth=records[i].imonth;
					  let updatedProjects =records[i].updatedProjects;
					  try{
					  		
							  _rows.push({ 
								imonth:imonth,
								updatedProjects:updatedProjects
							});
					  }catch(e){

					  }
					} // loop
					setProgressCountRows(_rows);
				}
				
			}
			
		}).catch((er)=>{
			console.log(er);
		})
  }

  const fetchProjectsBlockWise=async()=>{
	let i=0;
	let data_blockProjectCounts=[];
	let data_blockProjectAmounts=[];
	let data_geoDensity=[];
	let _tongoing=0;
	let _tcompleted=0;
	let _tdelayed=0;
	let _tdelayedDays=0;
	let _texpenditure=0;
	let _tNotInUse=0;
	let _currentDate=new Date();
	const ONE_DAY_TIME=1000*60*60*24;
	for(i=0;i<BLOCKS.length;i++){
		let blockName=BLOCKS[i];
		let j=0;
		let count=0;
		let amount=0;
		
		for(j=0;j<rows.length;j++){
			if(blockName===rows[j].block){
				count++;
				try{
				amount=amount+Number(rows[j].agrCost);
				}catch(ex){}
			}
			// online first time
			if(i===0){
				if(rows[j].workStatus==="Ongoing"){
					_tongoing=_tongoing+1;
					try{
						let estWorkStartDate=rows[j].estWorkStartDate;
						let estWorkCompleteByDays=parseInt(rows[j].estWorkCompleteByDays);
						let _date=new Date(estWorkStartDate);
						_date.setDate(_date.getDate()+estWorkCompleteByDays);
						let _dtime=_currentDate.getTime()-_date.getTime();
						if(_dtime>0){
							_tdelayed=_tdelayed+1;
							if(estWorkStartDate!="0001-01-01")
								_tdelayedDays=_tdelayedDays+Math.floor(_dtime/ONE_DAY_TIME);
						}
					}catch(e){}
				}
				if(rows[j].workStatus==="Completed"){
					_tcompleted=_tcompleted+1;
					if(rows[j].inUse=='No') _tNotInUse=_tNotInUse+1;
				}
				
				try{
					_texpenditure=_texpenditure+Number(rows[j].agrCost);
					if(parseFloat(rows[j].lat)>23 && parseFloat(rows[j].lng)<85)
						data_geoDensity.push([parseFloat(rows[j].lat),parseFloat(rows[j].lng)]);
				}catch(e){}
			}
		}
		
		data_blockProjectCounts[i]=count;
		data_blockProjectAmounts[i]=amount;
	}
	setTotalCompletedCount(_tcompleted);
	setTotalOngoingCount(_tongoing);
	setTotalProjectCount(rows.length);
	setCrossDeadline(_tdelayed);
	setNotInUse(_tNotInUse);
	let tmpADDs=Math.floor(_tdelayedDays/_tdelayed);
	let _DAYS=tmpADDs;
	let _YEARS=Math.floor(_DAYS/365); _DAYS=_DAYS%365;
	let _MONTHS=Math.floor(_DAYS/30); _DAYS=_DAYS%30;
	setAverageDelayedDays(_YEARS+"y, "+_MONTHS+"m, "+_DAYS+"d");
	
	setTotalExpenditure((_texpenditure/10000000));
	setProjectsBlockWiseChart((prev)=>{return {...prev,
												series:[{
													name: 'Projects',
													data: data_blockProjectCounts
												  }
												]
							}});
	setAmountProjectsBlockWiseChart((prev)=>{return {...prev,
								series:[{
									name: 'Amount',
									data: data_blockProjectAmounts
								  }
								]
							}});
	setProjectsGeoDensityChart((prev)=>{return {...prev,
								series:[{
									name: 'Lontitude',
									data: data_geoDensity
								}
								]
							}});												
  }

  async function fetchPerformanceCategory(){
	
		let _rows=[];
		let _d={
			token:localStorage.getItem("_xoxex"),
			email:localStorage.getItem("_xoxem"),
		};
		let idata=stringToHex(JSON.stringify(_d));
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/document/get-performance-count-by.php",
			headers: { 
				'Content-Type': 'application/x-www-form-urlencoded',
				//'Content-Type': 'application/json', 
			},
			data:"i="+idata
		  };
		  const _performanceCount={
			"b30":0,
			"b50":0,
			"b70":0,
			"b100":0
		}  
		await axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					let data=response.data;
					if(data.status===1 && data.data && data.data.length>0){
						const recs=data.data;
						
						for(let i=0;i<recs.length;i++){
							const pr=recs[i];
							if(pr.label=="b30") _performanceCount.b30=pr.performance;
							else if(pr.label=="b50") _performanceCount.b50=pr.performance;
							else if(pr.label=="b70") _performanceCount.b70=pr.performance;
							else if(pr.label=="b100") _performanceCount.b100=pr.performance;
						}
						setPerformanceCount(_performanceCount);

					}
				}
			});
	    
  }

  async function fetchDelayCount(){
	
	let _rows=[];
	let _d={
		token:localStorage.getItem("_xoxex"),
		email:localStorage.getItem("_xoxem"),
	};
	let idata=stringToHex(JSON.stringify(_d));
	var config = {
		method: 'post',
		url: API_CORE_SERVER+"/api/document/get-delay-count-by.php",
		headers: { 
			'Content-Type': 'application/x-www-form-urlencoded',
			//'Content-Type': 'application/json', 
		},
		data:"i="+idata
	  };
	  const _delayCount={
		"d30":0,
		"d60":0,
		"d90":0,
		"d180":0
	}  
	await axios(config)
		.then((response)=>{
			if(response.status===200 && response.data){
				let data=response.data;
				if(data.status===1 && data.data && data.data.length>0){
					const recs=data.data;
					
					for(let i=0;i<recs.length;i++){
						const pr=recs[i];
						if(pr.label=="d30") _delayCount.d30=parseInt(pr.count);
						else if(pr.label=="d60") _delayCount.d60=parseInt(pr.count);
						else if(pr.label=="d90") _delayCount.d90=parseInt(pr.count);
						else if(pr.label=="d180") _delayCount.d180=parseInt(pr.count);
					}
					
					setDelayCount(_delayCount);
					setProjectsDelayBetween((prev)=>{return {...prev,
						series:[_delayCount.d30,_delayCount.d60,_delayCount.d90,_delayCount.d180]
						
					}});
				}
			}
		});
	//console.log(_delayCount)			
}

async function fetchStarsCount(){
	
	let _rows=[];
	let _d={
		token:localStorage.getItem("_xoxex"),
		email:localStorage.getItem("_xoxem"),
	};
	let idata=stringToHex(JSON.stringify(_d));
	var config = {
		method: 'post',
		url: API_CORE_SERVER+"/api/remarks/get-stars-group.php",
		headers: { 
			'Content-Type': 'application/x-www-form-urlencoded',
			//'Content-Type': 'application/json', 
		},
		data:"i="+idata
	  };
	  const _starts={
		"first":0,
		"second":0,
		"third":0,
		"four":0,
		"five":0
	}  
	await axios(config)
		.then((response)=>{
			if(response.status===200 && response.data){
				let data=response.data;
				if(data.status===1 && data.data && data.data.length>0){
					const recs=data.data;
					
					for(let i=0;i<recs.length;i++){
						const pr=recs[i];
						if(pr.rates=="1") _starts.first=pr.count;
						else if(pr.rates=="2") _starts.second=pr.count;
						else if(pr.rates=="3") _starts.third=pr.count;
						else if(pr.rates=="4") _starts.four=pr.count;
						else if(pr.rates=="5") _starts.five=pr.count;
					}
					setStartsCount(_starts);
					
				}
			}
		});
			
}
  
return(
	<>
	<div className='row'>
		<div class="row">
		<div className='col-md-12 px-4'>
			<div className='d-flex gap-4'>
				<div className='d-flex flex-fill gap-4'>
						<div className='d-flex flex-column cursor-pointer'
						onClick={e=>{
							navigate(URLPREFIX+"/list/document",{state:{requestFor:"total-project"}})
						}}
						>
							<div className='fs-2 text-center'>{totalProjectCount}</div>
							<div className='fs75rem text-gray-hard text-center'>Total Project/Assets</div>
						</div>
						<div className='d-flex flex-column cursor-pointer'
						onClick={e=>{
							navigate(URLPREFIX+"/list/document",{state:{requestFor:"ongoing-project"}})
						}}
						>
							<div className='fs-2 text-center'>{totalOngoingCount}</div>
							<div className='fs75rem text-gray-hard text-center'>Ongoing</div>
						</div>
						<div className='d-flex flex-column cursor-pointer'
						onClick={e=>{
							navigate(URLPREFIX+"/list/document",{state:{requestFor:"completed-project"}})
						}}
						>
							<div className='fs-2 text-center'>{totalCompletedCount}</div>
							<div className='fs75rem text-gray-hard text-center'>Completed</div>
						</div>
						<div className='d-flex flex-column cursor-pointer'
						onClick={e=>{
							navigate(URLPREFIX+"/list/document",{state:{requestFor:"cross-deadline-project"}})
						}}
						>
							<div className='fs-2 text-center'>{crossDeadline}</div>
							<div className='fs75rem text-gray-hard text-center'>Cross deadline</div>
						</div>
						<div className='d-flex flex-column'>
							<div className='fs-2 text-center'>{averageDelayedDays}</div>
							<div className='fs75rem text-gray-hard text-center'>Average Delay</div>
						</div>
						<div className='d-flex flex-column cursor-pointer'
						onClick={e=>{
							navigate(URLPREFIX+"/list/document",{state:{requestFor:"not-inuse"}})
						}}>
							<div className='fs-2 text-center'>{notInUse}</div>
							<div className='fs75rem text-gray-hard text-center'>Not Inuse</div>
						</div>
						
				</div>	
				<div class="d-flex justify-content-end">
						<div className='d-flex flex-column cursor-pointer  border rounded rounded p-2'>
							<div className='fs85rem text-black fw-bold text-center'>{totalExpenditure.toFixed(2)} Cr</div>
							<div className='fs75rem text-gray-hard text-center'>Total.Cost</div>
						</div>
				</div>	
			</div>
		</div>
		</div>
		{/*<div className='col-md-6'>
			<h5>Create Documents</h5>
			<p className='text-justify text-gray-hard'>
				To use encoded Unicode characters in content you need to provide either the characters 
				themselves (as you do), or their UTF-8 escape sequences instead of HTML entities:
			</p>
			<div className='text-end'> 
				<div className="btn-group">
					<button type="button" className="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
					Select Form <i className='bi bi-caret-down-fill'></i>
					</button>
					<ul className="dropdown-menu dropdown-menu-dark">
						{Object.keys(DOCUMENT_LIST).map((data,index)=>{
							return(
								<li><Link className="dropdown-item" to={URLPREFIX+"/create/document/"+data}>{DOCUMENT_LIST[data].longName}</Link></li>
						)})}
						
					</ul>
				</div>	
			</div>
		</div>
		<div className='col-md-6 p-4'>
			
		</div>
							*/}
		<div class="row">
			<div className='col-md-7 p-4'>
				<div className='card p-4'>
				<Chart options={projectsBlockWiseChart.options} series={projectsBlockWiseChart.series} type="bar" height={350} />
				<h5 className='text-center'>Projects count block-wise</h5>
				</div>
				<div className='card p-4 mt-4'>
				<Chart options={projectsAmountBlockWiseChart.options} series={projectsAmountBlockWiseChart.series} type="bar" height={350} />
				<h5 className='text-center'>Projects cost block-wise </h5>
				</div>
				
			</div>
			<div className='col-md-5 p-4'>
				<div className='d-flex flex-column flex-fill bg-warning border border-warning rounded p-2 mb-2'>
					{
						progressCountRows.length>=1 && 
						<>
						<table>
							<thead>
								<th align='left'>Month</th>
								<th align='right'>Project Updated</th>
							</thead>
						{progressCountRows.map((item,index)=>{
							return(
								<tr>
									<td>{item.imonth}</td>
									<td align='right'>{item.updatedProjects}</td>
								</tr>
							);
						})
						}
						</table>
						</>
					}
				</div>
				<div className='d-flex flex-column flex-fill bg-warning border border-warning rounded p-2'>
						<h5 className='text-center'>Projects performance wise</h5>
						<div className='d-flex justify-content-center flex-fill gap-2'>
							<div className='d-flex flex-fill flex-column'>
								<div className='fs-4 text-center'>{performanceCount.b30}</div>
								<div className='fs75rem text-gray-hard text-center'>&lt;30%</div>
							</div>
							<div className='d-flex flex-fill flex-column'>
								<div className='fs-4 text-center'>{performanceCount.b50}</div>
								<div className='fs75rem text-gray-hard text-center'>&lt;50%</div>
							</div>
							<div className='d-flex flex-fill flex-column'>
								<div className='fs-4 text-center'>{performanceCount.b70}</div>
								<div className='fs75rem text-gray-hard text-center'>&lt;70%</div>
							</div>
							<div className='d-flex flex-fill flex-column'>
								<div className='fs-4 text-center'>{performanceCount.b100}</div>
								<div className='fs75rem text-gray-hard text-center'>&lt;=100%</div>
							</div>
						</div>
				</div>
				<div className='d-flex flex-column flex-fill bg-danger border border-warning rounded p-2 mt-4'>
						<h5 className='text-center text-white'>Delayed Projects</h5>
						<div className='d-flex justify-content-center flex-fill gap-2'>
							<div className='d-flex flex-fill flex-column cursor-pointer'
							onClick={e=>{
								navigate(URLPREFIX+"/list/document/delayed-projects-between-days",{state:{requestFor:"delayed-between-days",id:"xxxxxxx",wstatus:"Ongoing",name:"Delayed Projects [30-60 days]",x:30,y:60}})	
							}}
							>
								<div className='fs-4 text-center text-white'>{delayCount.d30}</div>
								<div className='fs75rem text-gray-hard text-center text-white'>30-60 days</div>
							</div>
							<div className='d-flex flex-fill flex-column cursor-pointer'
							onClick={e=>{
								navigate(URLPREFIX+"/list/document/delayed-projects-between-days",{state:{requestFor:"delayed-between-days",id:"xxxxxxx",wstatus:"Ongoing",name:"Delayed Projects [60-90 days]",x:60,y:90}})	
							}}
							>
								<div className='fs-4 text-center text-white'>{delayCount.d60}</div>
								<div className='fs75rem text-gray-hard text-center text-white'>60-90 days</div>
							</div>
							<div className='d-flex flex-fill flex-column cursor-pointer'
							onClick={e=>{
								navigate(URLPREFIX+"/list/document/delayed-projects-between-days",{state:{requestFor:"delayed-between-days",id:"xxxxxxx",wstatus:"Ongoing",name:"Delayed Projects [90-180 days]",x:90,y:180}})	
							}}
							>
								<div className='fs-4 text-center text-white'>{delayCount.d90}</div>
								<div className='fs75rem text-gray-hard text-center text-white'>90-180 days</div>
							</div>
							<div className='d-flex flex-fill flex-column cursor-pointer'
							onClick={e=>{
								navigate(URLPREFIX+"/list/document/delayed-projects-between-days",{state:{requestFor:"delayed-between-days",id:"xxxxxxx",wstatus:"Ongoing",name:"Delayed Projects [180-above days]",x:180,y:100000000}})	
							}}
							>
								<div className='fs-4 text-center text-white'>{delayCount.d180}</div>
								<div className='fs75rem text-gray-hard text-center text-white'>180-above days</div>
							</div>
						</div>
						<Chart options={projectsDelayBetween.options} series={projectsDelayBetween.series} type="pie" height={350} />
						
				</div>
			</div>
		</div>
		<div className='col-md-12 p-4 bg-light'>
			<div className='d-flex justify-content-center gap-2'>
					<div className='d-flex justify-content-center border rounded-pill cursor-pointer' style={{width:'180px',height:'180px'}}
					onClick={e=>{
						navigate(URLPREFIX+"/list/public/remarks",{state:{stars:"5",id:"s5",wstatus:"Ongoing",name:"5 Stars remarked list"}})	
					}}
					>
						<div className='align-self-center text-center'>
							<div className='fs-2'>{starsCount.five}</div>
							<div className='fs-6'>
								<i class="bi bi-star-fill text-success"></i>
								<i class="bi bi-star-fill text-success"></i>
								<i class="bi bi-star-fill text-success"></i>
								<i class="bi bi-star-fill text-success"></i>
								<i class="bi bi-star-fill text-success"></i>
							</div>
						</div>
					</div>
					<div className='d-flex justify-content-center border rounded-pill cursor-pointer' style={{width:'180px',height:'180px'}}
					onClick={e=>{
						navigate(URLPREFIX+"/list/public/remarks",{state:{stars:"4",id:"s4",wstatus:"Ongoing",name:"4 Stars remarked list"}})	
					}}
					>
						<div className='align-self-center text-center'>
							<div className='fs-2'>{starsCount.four}</div>
							<div className='fs-6'>
								<i class="bi bi-star-fill text-primary"></i>
								<i class="bi bi-star-fill text-primary"></i>
								<i class="bi bi-star-fill text-primary"></i>
								<i class="bi bi-star-fill text-primary"></i>
								<i class="bi bi-star text-primary"></i>
							</div>
						</div>
					</div>
					<div className='d-flex justify-content-center border rounded-pill cursor-pointer' style={{width:'180px',height:'180px'}}
					onClick={e=>{
						navigate(URLPREFIX+"/list/public/remarks",{state:{stars:"3",id:"s3",wstatus:"Ongoing",name:"3 Stars remarked list"}})	
					}}
					>
						<div className='align-self-center text-center'>
							<div className='fs-2'>{starsCount.third}</div>
							<div className='fs-6'>
								<i class="bi bi-star-fill text-warning"></i>
								<i class="bi bi-star-fill text-warning"></i>
								<i class="bi bi-star-fill text-warning"></i>
								<i class="bi bi-star text-warning"></i>
								<i class="bi bi-star text-warning"></i>
							</div>
						</div>
					</div>
					<div className='d-flex justify-content-center border rounded-pill cursor-pointer' style={{width:'180px',height:'180px'}}
					onClick={e=>{
						navigate(URLPREFIX+"/list/public/remarks",{state:{stars:"2",id:"s2",wstatus:"Ongoing",name:"2 Stars remarked list"}})	
					}}
					>
						<div className='align-self-center text-center'>
							<div className='fs-2'>{starsCount.second}</div>
							<div className='fs-6'>
								<i class="bi bi-star-fill text-danger"></i>
								<i class="bi bi-star-fill text-danger"></i>
								<i class="bi bi-star text-danger"></i>
								<i class="bi bi-star text-danger"></i>
								<i class="bi bi-star text-danger"></i>
							</div>
						</div>
					</div>
					<div className='d-flex justify-content-center border rounded-pill cursor-pointer' style={{width:'180px',height:'180px'}}
					onClick={e=>{
						navigate(URLPREFIX+"/list/public/remarks",{state:{stars:"1",id:"s1",wstatus:"Ongoing",name:"One Star remarked list"}})	
					}}
					>
						<div className='align-self-center text-center'>
							<div className='fs-2'>{starsCount.first}</div>
							<div className='fs-6'>
								<i class="bi bi-star-fill text-danger"></i>
								<i class="bi bi-star text-danger"></i>
								<i class="bi bi-star text-danger"></i>
								<i class="bi bi-star text-danger"></i>
								<i class="bi bi-star text-danger"></i>
							</div>
						</div>
					</div>
			</div>
			<div className='text-6 text-center mt-4 text-muted fw-bold'>Service Rating by Citizens</div>
		</div>
		<div className='col-md-12 p-4'>
			<Chart options={projectsGeoDensityChart.options} series={projectsGeoDensityChart.series} type="scatter" height={350} />
			<h5 className='text-center'>Geo density </h5>
		</div>
	</div>
	</>

);
};
export default JComponent;